// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281604/js/" + chunkId + "." + {"44":"1f0a008d","225":"20a0b204","481":"5f30f4ce","486":"ae4201a9","770":"7a3c8117"}[chunkId] + ".0.45614855037746993.chunk.js";
};